import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hos",
  "use": "hos-usage",
  "viewBox": "0 0 107 108",
  "content": "<symbol viewBox=\"0 0 107 108\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hos\"><path d=\"M.178 47.676c4.25-35 34.75-44.5 34.75-44.5-40.75 43.5 8 74.5 8 74.5l-33 7.25c.25 0-11.5-14-9.75-37.25z\" /><path d=\"M74.428 103.176c-35 12.75-55.5-9.5-55.5-9.5 57.25 14.5 61.25-43.5 61.25-43.5l22 25.25s-6.25 18-27.75 27.75z\" /><path d=\"M105.678 63.426c-17.5-57.25-66.75-30-66.75-30l10.5-33.25s21-2.75 40 13.5c23.25 20.25 16.25 49.75 16.25 49.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol